import React from 'react';
import { cn } from '@/lib/utils';

interface DividerProps {
  /** Optional centred label, e.g. "or". */
  label?: string;
  className?: string;
}

const Divider: React.FC<DividerProps> = ({ label, className }) => {
  if (!label) return <hr className={cn('tw-h-px tw-w-full tw-border-0 tw-bg-ds-border-default', className)} />;

  return (
    <div role="separator" className={cn('tw-flex tw-w-full tw-items-center tw-gap-3', className)}>
      <span className="tw-h-px tw-flex-1 tw-bg-ds-border-default" />
      <span className="tw-text-[13px] tw-font-medium tw-leading-[18px] tw-text-ds-text-tertiary">{label}</span>
      <span className="tw-h-px tw-flex-1 tw-bg-ds-border-default" />
    </div>
  );
};

export default Divider;
